export enum MemberTypeEnum {
  // 个人专业投资者
  INDIVIDUAL = 'individual',
  // 企业专业投资者
  COMPANY = 'enterprise',
  // 机构专业投资者
  INSTITUTION = 'institution',
}

// PI子类型enum
export enum MemberCategoryEnum {
  // 个人
  INDIVIDUAL = 0,
  // 企业
  LISTED_COMPANY = 1, // 上市公司
  PRIVATE_COMPANY = 2, // 私人公司（个人投资公司、非上市公司）
  PARTNERSHIP = 3, // 合伙企业和非注册企业
  UNREGULATED_TRUSTEE = 4, // 不受监管的受托人
  PRIVATE_FOUNDATION = 5, // 私人基金会（私人捐赠或非慈善基金会的基金会）
  NOT_FOR_PROFIT_CHARITABLE = 6, // 非营利/慈善机构和基金会
  // 机构
  REGULATED_INSTITUTION = 7, // 受监管机构
  OTHER_INVESTMENT = 8, // 另类投资
  TRUSTEE = 9, // 信托 受托人
  NOMINEE_ACCOUNT = 10, // 代名账户（只适用于综合户口而已）
}

export enum investorsTypeEnum {
  individual = 2,
  enterprise = 1,
  institution = 0,
}

export const memberTypes = [
  {
    type: MemberTypeEnum.INDIVIDUAL,
    title: 'account.index.typeSelect.individual.title',
    icon: 'ri:home-3-line',
    description: 'account.index.typeSelect.individual.description',
  },
  {
    type: MemberTypeEnum.COMPANY,
    title: 'account.index.typeSelect.company.title',

    icon: 'ri:home-3-line',
    description: 'account.index.typeSelect.company.description',
  },
  {
    type: MemberTypeEnum.INSTITUTION,
    title: 'account.index.typeSelect.institutional.title',
    icon: 'ri:home-3-line',
    description: 'account.index.typeSelect.institutional.description',
  },
];

export enum FormTypeEnum {
  /** 实体资讯 */
  ENTITY = 'entity',
  /** 纳税证明 */
  TAX = 'tax',
  /** 董事会决议 */
  RESOLUTION = 'resolution',
  /** 适应性评估 */
  QUESTION = 'question',
  /** 档案上传 */
  ARCHIVE = 'archive',
  /** 会员协议签署 */
  SIGNATURE = 'signature',
  /** 结果通知 */
  RESULT = 'result',
}

export enum ValidTypeEnum {
  /** 校验成功 */
  SUCCESS = 2,
  /** 校验失败 */
  FAIL = 1,
}

// 是否保存
export enum SaveTypeEnum {
  Yes = 1,
  No = 0,
}

export enum MaleTypeEnum {
  MR = 'mr',
  MRS = 'mrs',
  MS = 'ms',
  MISS = 'miss',
  OTHER = 'other',
}

export enum StatusTypeEnum {
  /** 信息填写中 */
  DRAFT = 0,
  /** 信息审核中 */
  APPLICATION_REVIEWING = 1,
  /** 银行账号信息填写中 */
  BANK_INFO_DRAFT = 2,
  /** 银行账号信息审核中 */
  BANK_INFO_REVIEWING = 3,
  /** 完成 */
  DONE = 4,
  /** 驳回 */
  REJECT = 5,
}

export enum FundsSourceTypeEnum {
  /** 投资准备金 */
  INVESTMENT = 0,
  /** 额外资金 */
  EXCESS = 1,
  /** 其它 */
  OTHER = 2,
  /** 薪水 */
  SALARY = 3,
  /** 遗产 */
  INHERITANCE = 4,
  /** 营业盈利 */
  BUSINESS_PROFIT = 5,
  /** 公司资金 */
  HOUSE_CAPITAL = 6,
  /** 每月收入 / 入息 */
  MONTH_LY_INCOME = 7,
}

export enum InvestmentPurposeTypeEnum {
  /** 投机 */
  SPECULATION = 0,
  /** 资本增值 */
  CAPITAL_GAINS = 1,
  /** 定期收入 */
  REGULAR_INCOME = 2,
  /** 其他 */
  OTHER = 3,
}

// 是否完成开户
export enum CompleteOpenAccountTypeEnum {
  Yes = 1,
  No = 0,
}

// 税务编号无法提供理由类型
export enum NoTinReasonTypeEnum {
  A = 0,
  B = 1,
  C = 2,
}

/** 企業種類 */
export enum TaxEntityTypeEnum {
  /** 金融机构 */
  FINANCIAL_INSTITUTION = 0,
  /** Active NFE 主动非金融海外機構 */
  ACTIVE_NFE = 1,
  /** Passive NFE 非主動非金融海外機構 */
  PASSIVE_NFE = 2,
}

/** 金融機構类型 */
export enum TaxFinancialInstitutionTypeEnum {
  /** 监护机构 */
  GUARDIAN = 0,
  /** 投资机构 */
  INVESTOR = 1,
}

/** 主动非金融海外機構类型 */
export enum TaxActiveNfeTypeEnum {
  /** 企业 */
  CORPORATION = 0,
  /** 和企业相关机构 */
  RELATED_CORPORATION = 1,
  /** 政府机构 */
  GOVERNMENT = 2,
  /** 其他 */
  OTHERS = 3,
}

/** 非主動非金融海外機構类型 */
export enum TaxPassiveNfeTypeEnum {
  /** 該投資機構位置在澳門以外和經其他金融機構管理 */
  OUTSIDE_MACAU = 0,
  /** 不屬主動非財務實體的非財務實體 */
  NOT_ACTIVE_NFE = 1,
}

/** 控权人类型->机构类别 */
export enum TaxPersonTypeEntityTypeEnum {
  /** 个人持有控权人拥有权（例：不少过25%股份） */
  CONTROLLING_OWNERSHIP_INTEREST = 0,
  /** 个人持有其他控权（例: 不少过25%投票权利） */
  CONTROL_THROUGH_OTHER_MEANS = 1,
  /** 个人持有高级管理者职位或拥有该公司管理权力 */
  SENIOR_MANAGING_POSITION = 2,
}
/** 控权人类型->Trust */
export enum TaxPersonTypeTrustEnum {
  /** 信托创立人 */
  SETTLOR = 0,
  /** 受托人 */
  TRUSTEE = 1,
  /** 保护者 */
  PROTECTOR = 2,
  /** 授权人 */
  BENEFICIARY = 3,
  /** 其他 */
  OTHER = 4,
}
/** 控权人类型->法律安排 */
export enum TaxPersonTypeLegalArrangementEnum {
  /** 个人职位与信托创立人相似 */
  SIMILAR_TO_SETTLOR = 0,
  /** 个人职位与受托人相似 */
  SIMILAR_TO_TRUSTEE = 1,
  /** 个人职位与保护者相似 */
  SIMILAR_TO_PROTECTOR = 2,
  /** 个人职位与授权人相似 */
  SIMILAR_TO_BENEFICIARY = 3,
  /** 其他 */
  OTHER = 4,
}
/** 机构的选项 */
export enum CorporateTypeEnum {
  /** 受监管机构 */
  INSTITUTION = 0,
  /** 另类投资 */
  OTHER_INVESTMENT = 1,
  /** 信托机构 */
  TRUST = 2,
  /** 代名账户 */
  NOMINEE = 3,
  /** 公司 */
  ENTERPRISE = 4,
  /** 合伙 */
  PARTNERSHIP = 5,
  /** 信托机构 */
  TRUST2 = 6,
  /** 其他 */
  OTHERS = 7,
}

export enum BusinessNatureEnum {
  /** 银行 */
  BANKS = 0,
  /** 保险公司 */
  INSURANCE = 1,
  /** 经纪自营商 */
  BROKER_DEALERS = 2,
  /** 家族办公室 */
  FAMILY_OFFICES = 3,
  /** 投资公司 */
  INVESTMENT = 4,
  /** 其他金融机构 */
  OTHER_FINANCIAL = 5,
  /** 政府机构 */
  GOVERNMENT = 6,
  /** 其他 */
  OTHERS = 7,
}

export enum FundsSourceEnum {
  /** 投资准备金 */
  INVESTMENT = 0,
  /** 额外资金 */
  EXCESS = 1,
  /** 其他 */
  OTHERS = 2,
  /** 公司资金 */
  HOUSE_CAPITAL = 3,
  /** 每月收入 / 入息 */
  MONTH_LY_INCOME = 4,
}
export enum mcexPurposeEnum {
  /** 资本增值 */
  CAPITALAPPRECIATION = 0,
  /** 资产配置 */
  ASSETALLOCATION = 1,
  /** 稳定收入 */
  STABLEINCOME = 2,
  /** 结构化融资 */
  STRUCTUREDFINANCING = 3,
  /** 其他 */
  OTHERS = 4,
}

// 协议类型
export enum AgreeTypeEnum {
  MEMBER_AGREE = 'memberAgree',
  DRO_AGREE = 'droAgree',
}

export enum RiskLevelEnum {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}
export const RiskLevelLabel = {
  [RiskLevelEnum.LOW]: '低风险',
  [RiskLevelEnum.MEDIUM]: '中等风险',
  [RiskLevelEnum.HIGH]: '高风险',
};
export const RiskLevelColor = {
  [RiskLevelEnum.LOW]: 'var(--primary-color-2)',
  [RiskLevelEnum.MEDIUM]: 'var(--emphasis-text)',
  [RiskLevelEnum.HIGH]: 'var(--danger-color)',
};

// 董事会文件类型
export enum DirectDocTypeEnum {
  RESOLUTION = 0, // 董事会决议
  CERTIFICATE = 1, // 董事会证明书
}

// 币种类型
export enum CurrencyTypeEnum {
  RMB = 'RMB',
  MOP = 'MOP',
  HKD = 'HKD',
  USD = 'USD',
  CNY = 'CNY',
}
export enum PiStatusEnum {
  /** 有效1 */
  VALID = 1,
  /** 注销2 */
  CANCEL = 2,
}

export enum FormationTypeEnum {
  /** 法律实体识别编码的登记文件号码 */
  LEGAL_ENTITY_ID,
  /** 公司注册号码 */
  COMPANY_REGISTRATION,
  /** 商业登记号码 */
  BUSINESS_REGISTRATION,
  /** 其他同等的身份证明文件号码 */
  OTHER_IDENTIFICATION,
}
